import "../style/style-cargando.css";
import { useTranslation } from "react-i18next";

const NoContentCard = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center mt-8">
            <div style={{ marginTop: 10 }}>
                <p>{t("label_sin_contenido")}</p>
            </div>
        </div>
    );
};

export default NoContentCard;
